import { Button } from "@/components/ui/button";
import { ChevronRight, LucideIcon } from 'lucide-react';

interface ReportCardProps {
  title: string;
  description: string;
  icon: LucideIcon;
  onClick: () => void;
}

export const ReportCard = ({ title, description, icon: Icon, onClick }: ReportCardProps): React.ReactNode => {
  return (
    <Button
      variant="outline"
      className="w-full justify-between h-auto py-4"
      onClick={onClick}
    >
      <div className="flex items-center gap-3">
        <Icon className="h-5 w-5 flex-shrink-0" />
        <div className="text-left">
          <div className="font-medium">{title}</div>
          <div className="text-xs text-muted-foreground">{description}</div>
        </div>
      </div>
      <ChevronRight className="h-5 w-5 flex-shrink-0" />
    </Button>
  );
};
